import React, { useEffect, useRef, useState } from "react";
import AccountImg from "../../assets/images/Account.png";
import { Dropdown } from "react-bootstrap";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { generatePresignedUrl } from "../../api/common-store-api";
import { getUserProfileAsync } from "../../reducers/user-reducers";
import DefaultUserImage from "../../assets/images/defaultUserImg.png";
import UserImage from "../UserImage/UserImage";
import getInitialsInName from "../../helper/GetNameInitials";
import AuthService from "../../services/AuthService";
import { switchRoleAsync } from "../../reducers/user-reducers";
import LogOutPopup from "../ModalPopup/LogOutPopup";
import { Modal } from "react-bootstrap";

const AccountDropdown = ({ formDataReady }) => {
  const dispatch = useDispatch();
  let imgRef = useRef();
  const [logoutModel, setLogoutModel] = useState(false);
  const history = useHistory();
  const [userProfile, setUserProfile] = useState(null);
  const [newMode, setNewMode] = useState("");
    const authService = new AuthService();
    
  const handleLogout = () => {

    // const newMode = userProfile?.roleName;
    // authService.logout();
    // history.push("/");
    const res = dispatch(switchRoleAsync(newMode));
    if (res) {
      authService.logout();
      history.push("/");
    }
  };

  const getUserProfile = () => {
    dispatch(getUserProfileAsync()).then((res) => {
      if (res.payload) {
        setUserProfile(res.payload);
        // getPreviewUrl(res.payload.profileImagePath)
      }
    });
  };

  // const getPreviewUrl = async (profileImagePath) => {
  //   let previewUrl = await generatePresignedUrl(profileImagePath);
  //   if (previewUrl.data) {
  //         if(imgRef){
  //             imgRef.current.src = previewUrl.data
  //         }
  //   }
  // };

  useEffect(() => {
    getUserProfile();
  }, []);

  useEffect(() => {
    getUserProfile();
  }, [formDataReady]);

  useEffect(() => {
    if (userProfile?.roleName) {
      setNewMode(userProfile?.roleName);
    }
    if (userProfile?.isDeleted == true || userProfile?.status == 0) {
      authService.logout();
      history.push("/");
    }
  }, [userProfile]);
  // console.log(userProfile, "userProfile");
  return (
    <>
      <div className="headImg">
        <Dropdown className="accountDropdown">
          <Dropdown.Toggle>
            {/* <img src={AccountImg} alt="" /> */}
            {/* <img src={DefaultUserImage} alt="ProfileImg" ref={imgRef} /> */}
            {/* {userProfile ? <UserImage imgKey={userProfile.profileImagePath} /> : <img src={DefaultUserImage} alt="ProfileImg" ref={imgRef} />} */}
            {userProfile?.profileImagePath ? (
              <UserImage imgKey={userProfile.profileImagePath} />
            ) : (
              <img
                src={getInitialsInName(userProfile?.name ?? "N A", 24)}
                alt={userProfile?.name}
              />
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <NavLink className="dropdown-item" to="/accountsetting">
              Account Settings
            </NavLink>
            <button
              className="dropdown-item"
              onClick={() => setLogoutModel(true)}
            >
              Logout
            </button>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <Modal
        className="modalDialog modDeltemp"
        size="sm"
        centered
        show={logoutModel}
      >
        {logoutModel && (
          <LogOutPopup
            onCancel={setLogoutModel}
            onConfirm={handleLogout}
            headerLable="Would you like to logout Evantiv circles ?"
            chldLable="Click on ‘Yes, Logout ‘ for logging out from your account."
          />
        )}
      </Modal>
    </>
  );
};

export default AccountDropdown;
